// extracted by mini-css-extract-plugin
export default {"App":"App_App__CHXCB","holder":"App_holder__8n6ph"};